var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTrashCan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20007 7.84381H20.8154H4.20007Z",
    fill: "#525059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20007 7.84381H20.8154",
    stroke: "#F53C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27698 7.84381H18.7385V20.3053C18.7385 20.6726 18.5926 21.0247 18.333 21.2844C18.0733 21.5441 17.7211 21.6899 17.3539 21.6899H7.66159C7.29437 21.6899 6.94219 21.5441 6.68252 21.2844C6.42286 21.0247 6.27698 20.6726 6.27698 20.3053V7.84381Z",
    stroke: "#F53C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04626 7.84378V7.15148C9.04626 6.23342 9.41096 5.35296 10.0601 4.7038C10.7093 4.05464 11.5897 3.68994 12.5078 3.68994C13.4259 3.68994 14.3063 4.05464 14.9555 4.7038C15.6046 5.35296 15.9693 6.23342 15.9693 7.15148V7.84378",
    stroke: "#F53C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4309 10.613V18.2284",
    stroke: "#F53C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5847 10.613V18.2284",
    stroke: "#F53C5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrashCan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trashCan.9edb1c23.svg";
export { ForwardRef as ReactComponent };